import React, { useEffect, useState } from 'react'
import CcForm from './CcForm'

const StripeForm = (props) => {
    return (<>
              <CcForm moduleData={props?.moduleData} metadataMap={props?.metadataMap} currentPlan={props?.currentPlan} checkoutModuleData={props?.checkoutModuleData} isUpgrade={props?.isUpgrade}/>
        </>)
}

export default StripeForm